/* eslint-disable */

import { rootApi } from '../rootApi';

export const modelApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getAllModels: builder.query({
            query: (paramsFromHook) => {
                const { SearchText, PageNumber, PageSize, ...advancedFilters } = paramsFromHook;

                const body = {
                    SearchText: SearchText || '',
                    PageNumber: PageNumber !== undefined ? PageNumber : 1,
                    PageSize: PageSize || 10,
                    ...advancedFilters
                };

                return {
                    url: 'v1/systemdefinitions/getmodel',
                    method: 'POST',
                    body: body // Güncellenmiş gövdeyi API'ye gönder
                };
            },
            transformResponse: (response) => {
                console.log('🔍 Transform Response:', response);

                // Check if response has the expected structure with data property
                if (response && typeof response === 'object') {
                    if (response.data && Array.isArray(response.data.items)) {
                        console.log('✅ Extracted data array with', response.data.items.length, 'items'); // response.data.length yerine response.data.items.length olmalı
                        return response.data;
                    }

                    if (Array.isArray(response)) {
                        console.warn('⚠️ Response is an array, but expected { items: [], totalCount: number }. Total count might be missing.');
                        return { items: response, totalCount: response.length };
                    }
                }

                // Fallback: return empty array if structure doesn't match
                console.warn('⚠️ Response structure not as expected, returning default structure');
                return { items: [], totalCount: 0 }; // ModelPage'in beklediği yapıya uygun fallback
            },
            onQueryStarted: async (arg, { queryFulfilled }) => {
                console.log('🚀 getAllModels query started with:', arg);
                try {
                    const result = await queryFulfilled;
                    console.log('✅ getAllModels query fulfilled:', result);
                } catch (error) {
                    console.error('❌ getAllModels query failed:', error);
                }
            },
            providesTags: ['Model']
        }),
        getAllModelDropdownList: builder.query({
            query: (paramsFromHook) => {
                const { brandName, productGroup, modelName } = paramsFromHook;

                const body = {
                    brandName: brandName ?? '',
                    productGroup: productGroup ?? '',
                    modelName: modelName ?? ''
                };

                return {
                    url: 'v1/compound/getmodeldropdown',
                    method: 'POST',
                    body: body // Güncellenmiş gövdeyi API'ye gönder
                };
            },
            transformResponse: (response) => {
                console.log('🔍 Transform Response:', response);

                // Check if response has the expected structure with data property
                if (response && typeof response === 'object') {
                    console.log('🔍 Response:', response.data);
                    if (response.data && Array.isArray(response.data)) {
                        console.log('✅ Extracted data array with', response.data.length, 'items'); // response.data.length yerine response.data.items.length olmalı
                        return response.data;
                    }

                    if (Array.isArray(response)) {
                        console.warn('⚠️ Response is an array, but expected { items: [], totalCount: number }. Total count might be missing.');
                        return { items: response, totalCount: response.length };
                    }
                }

                // Fallback: return empty array if structure doesn't match
                console.warn('⚠️ Response structure not as expected, returning default structure');
                return { items: [], totalCount: 0 }; // ModelPage'in beklediği yapıya uygun fallback
            },
            onQueryStarted: async (arg, { queryFulfilled }) => {
                console.log('🚀 getAllModels query started with:', arg);
                try {
                    const result = await queryFulfilled;
                    console.log('✅ getAllModels query fulfilled:', result);
                } catch (error) {
                    console.error('❌ getAllModels query failed:', error);
                }
            },
            providesTags: ['Model']
        })
    })
});

export const { useGetAllModelsQuery, useGetAllModelDropdownListQuery } = modelApi;
